import angular from 'angular';

import SimpleModalComponent from './simple-modal.component';

const SimpleModalModule = angular
    .module('control-room.commons.basic.components.simple-modal', [])
    .component('crSimpleModal', SimpleModalComponent);

export default SimpleModalModule;
